<template>
	<div class="publicBox buyBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>购买卡券</li>
			</ul>
		</div>
		<!-- 公告横幅 -->
		<div class="announcement-banner" v-if="ruleList.length > 0">
			<div class="announcement-content">
				<img src="../../../assets/img/admin/buy.png" class="announcement-icon">
				<span class="announcement-label">活动公告</span>
				<div class="announcement-scroll">
					<div class="scroll-content">
						<span v-for="(rule, index) in ruleList" :key="rule.id" class="scroll-item">
							{{rule.bonusDescription}}
						</span>
					</div>
				</div>
			</div>
		</div>
		
		<div class="title">请选择要购买的金额或自定义输入金额面值：</div>
		<ul class="buyList row">
			<li class="fl flexBox" v-for="(item,idx) in buyList" :class="buyIdx == idx ? 'active' :''"
				@click="clickList(idx)">
				<div class="txt">
					<span>面<br>值</span>
				</div>
				<div class="val"><span>￥</span>{{item.val}}</div>
			</li>
			<li class="other fl">
				<div class="tip">自定义金额</div>
				<div class="flexBox">
					<a-input 
						v-model="buyForm" 
						placeholder="请输入金额" 
						@change="changeBuy"
						@input="validateInput"
						@keypress="preventDecimal"
						type="number"
						:min="1"
						:step="1"
					/>
					<div class="txt">元</div>
				</div>
			</li>
		</ul>
		<div class="tipBox">
			<div class="flexBox name">
				<img src="../../../assets/img/admin/icon_4.png" class="icon">
				<div class="txt">充值说明：</div>
			</div>
			<div class="tip">卡券购买成功以后请到【控制台】-【费用】-【卡券】-【现金券】查看明细；购买云资源结算时可直接使用现金券结算；卡券购买后不可退款，请按需购买；如有其他疑问请联系客服邮箱：cloud-service@zminfra.cn。</div>
		</div>

		<div class="infoBox">
			<span>充值金额：</span>￥{{buyVal}}
			<div class="bonus-offer" v-if="bonusAmount > 0">
				送 {{bonusAmount}} 元代金券
			</div>
		</div>
		<a-button class="btn" @click="clickBuy" :loading="payLoading" :disabled="payLoading">确认付款</a-button>

		<!-- 支付二维码弹窗 -->
		<a-modal class="publicModel" :width="'50rem'" v-model="showPaymentModal" :footer="null"
			:closable="false" :maskClosable="false" :centered="true" @cancel="closePaymentModal">
			<div class="titleBox">
				<div class="close" @click="() => showPaymentModal = false">
					<a-icon type="close" />
				</div>
			</div>
			<div class="payment-content">
				<div class="payment-info">
					<div class="amount">￥{{buyVal}}</div>
					<div class="order-no">订单号：{{orderNo}}</div>
				</div>
				<div class="qr-code-container" v-if="qrCode">
					<img :src="qrCode" alt="支付二维码" class="qr-code" @error="onQrCodeError">
				</div>
				<div class="qr-code-container" v-else>
					<div class="loading-qr">
						<a-spin size="large" />
						<div class="loading-text">正在生成二维码...</div>
					</div>
				</div>
				<div class="payment-actions">
					<a-button type="primary" @click="refreshPayment" :loading="payLoading"
						:disabled="payLoading">刷新二维码</a-button>
					<a-button @click="closePaymentModal">取消支付</a-button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		name: 'Buy',
		components: {},
		data() {
			return {
				buyList: [{
					val: 100,
					id: 0,
				}, {
					val: 300,
					id: 1,
				}, {
					val: 500,
					id: 2,
				}, {
					val: 1000,
					id: 3,
				}, {
					val: 2000,
					id: 4,
				}],
				buyIdx: 0,
				buyForm: null,
				buyVal: 100,
				showPaymentModal: false,
				qrCode: '',
				orderNo: '',
				payLoading: false,
				bonusAmount: 0,
				ruleList: [],
			}
		},
		mounted() {
			// 页面加载时，默认选择第一个卡片并获取奖励金额
			this.getBonusAmount(this.buyList[0].val);
			this.getRuleList();
		},
		beforeDestroy() {
			this.stopPaymentPolling();
		},
		methods: {
			clickList(idx) {
				this.buyIdx = idx;
				this.bonusAmount = 0; // 重置奖励金额
				this.covnBuyForm();
			},
			covnBuyForm() {
				const msg = this.buyList[this.buyIdx];
				if (msg != undefined) {
					this.buyVal = msg.val;
					// 选择预设金额时，清空输入框
					this.buyForm = null;
					// 调用接口获取奖励金额
					this.getBonusAmount(msg.val);
				}
			},
			preventDecimal(event) {
				// 阻止小数点、减号、加号等字符的输入
				if (event.key === '.' || event.key === '-' || event.key === '+' || event.key === 'e') {
					event.preventDefault();
					return false;
				}
			},
			validateInput(value) {
				// 只允许输入数字，移除小数点和其他非数字字符
				const numericValue = value.replace(/[^\d]/g, '');
				if (numericValue !== value) {
					this.buyForm = numericValue;
				}
				// 额外检查：如果包含小数点，强制移除
				if (value.includes('.')) {
					this.buyForm = numericValue;
				}
			},
			changeBuy() {
				if (this.buyForm && this.buyForm !== "") {
					// 确保是整数
					const intValue = parseInt(this.buyForm);
					if (intValue > 0) {
						this.buyForm = intValue;
						this.buyIdx = -1;
						this.buyVal = intValue; // 直接设置充值金额
						
						// 调用接口获取奖励金额
						this.getBonusAmount(intValue);
					} else {
						this.buyForm = null;
						this.buyVal = 0;
					}
				} else {
					this.buyVal = 0;
				}
			},
			clickBuy() {
				if (!this.buyVal || this.buyVal <= 0 || !Number.isInteger(this.buyVal)) {
					this.$message.error('请输入有效的整数充值金额');
					return;
				}

				this.$confirm({
					title: '确认支付',
					content: `确定要支付 ￥${this.buyVal} 吗？`,
					centered: true,
					onOk: () => {
						this.createPaymentOrder();
					},
					onCancel: () => {
						// 用户取消
					}
				});
			},
			async createPaymentOrder() {
				this.payLoading = true;
				try {
					const amount = Math.round(this.buyVal * 100); // 转换为分
					const body = `充值金额${this.buyVal}元`;

					// 使用 URLSearchParams 发送表单数据
					const formData = new URLSearchParams();
					formData.append('amount', amount.toString());
					formData.append('body', body);

					const response = await this.$reqToken("post", "/api/center/payment/create", formData);

					if (response.code === 200) {
						this.orderNo = response.data.orderNo;
						this.qrCode = response.data.qrCode;

						this.showPaymentModal = true;

						// 开始轮询支付状态
						this.startPaymentPolling();
					} else {
						this.$message.error(response.msg || '创建支付订单失败');
					}
				} catch (error) {
					this.$message.error('创建支付订单失败，请重试');
				};

				this.payLoading = false;
			},
			closePaymentModal() {
				this.showPaymentModal = false;
				this.qrCode = '';
				this.orderNo = '';
				this.stopPaymentPolling();
				this.buyVal = 100;
				this.buyIdx = 0;
				this.buyForm = null;
			},
			refreshPayment() {
				if (this.payLoading) return;
				this.qrCode = '';
				this.orderNo = '';
				this.createPaymentOrder();
			},
			startPaymentPolling() {
				// 每3秒检查一次支付状态
				this.paymentTimer = setInterval(() => {
					this.checkPaymentStatus();
				}, 3000);
			},
			stopPaymentPolling() {
				if (this.paymentTimer) {
					clearInterval(this.paymentTimer);
					this.paymentTimer = null;
				}
			},
			async checkPaymentStatus() {
				if (!this.orderNo) return;
				try {
					const response = await this.$reqToken("get", `/api/center/payment/query/${this.orderNo}`, {});
					if (response.code === 200 && response.data && response.data.trade_state === 'SUCCESS') {
						this.$message.success('支付成功！');
						this.closePaymentModal();
					}
				} catch (error) {
					
				}
			},
			onQrCodeError() {
				this.$message.error('二维码加载失败，请刷新重试');
			},
			async getBonusAmount(amount) {
				try {
					const formData = new URLSearchParams();
					formData.append('amount', amount.toString());
					const response = await this.$reqToken("post", "/api/center/rule/getBonusAmount", formData);
					
					if (response.code === 200) {
						this.bonusAmount = response.data;
					} 
				} catch (error) {
					console.error('调用奖励金额接口出错:', error);
				}
			},
			async getRuleList() {
				try {
					const response = await this.$reqToken("get", "/api/center/rule/getList");
					
					if (response.code === 200) {
						this.ruleList = response.data || [];
					}
				} catch (error) {
					console.error('获取规则列表失败:', error);
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/admin/buy.css");

	.payment-content {
		text-align: center;
		padding:  0  0 2rem;
	}

	.payment-info {
		margin-bottom: 2rem;
		text-align: center;
	}

	.payment-info .amount {
		font-size: 2.8rem;
		font-weight: bold;
		color: #1890ff;
		margin-bottom: 1rem;
	}

	.payment-info .order-no {
		font-size: 1.4rem;
		color: #666;
		margin-top: 0.5rem;
	}

	.qr-code-container {
		margin: 2rem 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.qr-code {
		width: 20rem;
		height: 20rem;
		border: 1px solid #e8e8e8;
		border-radius: 0.8rem;
		display: block;
		margin: 0 auto;
	}

	.qr-tip {
		margin-top: 1rem;
		font-size: 1.4rem;
		color: #666;
	}

	.payment-actions {
		margin-top: 2rem;
		text-align: center;
	}

	.payment-actions .ant-btn {
		margin: 0 1rem;
		min-width: 12rem;
		height: 3.6rem;
		line-height: 3.6rem;
		padding: 0 1.5rem;
		font-size: 1.4rem;
	}

	.loading-qr {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 20rem;
	}

	.loading-text {
		margin-top: 1rem;
		color: #666;
		font-size: 1.4rem;
	}

	.infoBox {
		display: flex;
		align-items: center;
		gap: 1rem;
		margin-bottom: 2rem;
	}

	.bonus-offer {
		color: #ff4d4f;
		padding: 0.5rem 1rem;
		border-radius: 0.4rem;
		font-size: 1.8rem;
		font-weight: 500;
		background-color: #fff;
	}

	.announcement-banner {
		width: 142rem;
		background: linear-gradient(135deg, #1890ff, #096dd9);
		color: white;
		padding: 1.5rem 2rem;
		margin: 2rem 0;
		border-radius: 0.8rem;
		box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
	}

	.announcement-content {
		display: flex;
		align-items: center;
		gap: 1rem;
	}

	.announcement-icon {
		width: 2rem;
		height: 2rem;
		filter: brightness(0) invert(1);
	}

	.announcement-label {
		width: 7%;
		font-size: 1.8rem;
		font-weight: 600;
		white-space: nowrap;
	}

	.announcement-text {
		font-size: 1.4rem;
		line-height: 1.6;
		flex: 1;
	}

	.announcement-scroll {
		flex: 1;
		overflow: hidden;
		position: relative;
	}

	.scroll-content {
		display: flex;
		white-space: nowrap;
		animation: scrollLeft 20s linear infinite;
	}

	.scroll-item {
		font-size: 2.0rem;
		line-height: 1.6;
		padding: 0 2rem 0 0;
		white-space: nowrap;
	}

	@keyframes scrollLeft {
		0% {
			transform: translateX(100%);
		}
		100% {
			transform: translateX(-50%);
		}
	}

	/* 鼠标悬停时暂停滚动 */
	.announcement-scroll:hover .scroll-content {
		animation-play-state: paused;
	}
</style>